import script from "./BatchSettingPage.vue?vue&type=script&setup=true&lang=js"
export * from "./BatchSettingPage.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__